<div class="center">
  <div class="Loader">
    <div></div>
    <div></div>
  </div>
</div>
